export function useRegionNames() {
  const nuxtApp = useNuxtApp()
  const regionNames = computed(() => new Intl.DisplayNames([nuxtApp.$i18n.localeProperties.value.language], { type: 'region' }))

  function getRegionName(countryCode = 'TW') {
    try {
      return regionNames.value.of(countryCode)
    } catch (error) {
      console.error(error)
      return ''
    }
  }

  return {
    getRegionName,
  }
}

export function useIntlNumber() {
  const i18n = useI18n()

  function getLocaleNumber(amount = 0, decimalCount = 0, locale) {
    try {
      return new Intl.NumberFormat(locale || i18n.localeProperties.value.language, {
        minimumFractionDigits: decimalCount,
        maximumFractionDigits: decimalCount,
      }).format(amount)
    } catch (error) {
      console.error(error)
      return '0'
    }
  }

  return {
    getLocaleNumber,
  }
}

export function useUpperCase() {
  const nuxtApp = useNuxtApp()

  function getLocaleUpperCaseString(str = '', locale) {
    try {
      const res = str.toLocaleUpperCase(locale || nuxtApp.$i18n.localeProperties.value.language)
      return res
    } catch (error) {
      console.error(error)
      return ''
    }
  }

  return {
    getLocaleUpperCaseString,
  }
}

export function useLowerCase() {
  const nuxtApp = useNuxtApp()

  function getLocaleLowerCaseString(str = '', locale) {
    try {
      const res = str.toLocaleLowerCase(locale || nuxtApp.$i18n.localeProperties.value.language)
      return res
    } catch (error) {
      console.error(error)
      return ''
    }
  }

  return {
    getLocaleLowerCaseString,
  }
}
